import React from "react";
import "../../styles/form.css";

export default function StepIndicator({ currentStep }) {
  const steps = ["Create Agent", "Lead Scoring", "Chatbox Configuration"];

  return (
    <div className="step-indicator">
      {steps.map((label, index) => (
        <React.Fragment key={index}>
          <div
            className={`step-item ${currentStep >= index + 1 ? "step-active" : ""}`}
          >
            <div className="step-number">{index + 1}</div>
            <span className="step-label">{label}</span>
          </div>

          {index < steps.length - 1 && <div className="step-divider"></div>}
        </React.Fragment>
      ))}
    </div>
  );
}
